import { createRouter, createWebHistory, RouterOptions, RouterScrollBehavior } from 'vue-router'
import { routes } from './routes'

const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) => {
  return { top: 0 }
}

const routerOptions: RouterOptions = {
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior,
}

const router = createRouter(routerOptions)

export default router
